import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XIcon } from "@heroicons/react/solid";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

export const Modal = ({
  show = false,
  onClose = () => {},
  title = "Modal",
  children,
  footer = null,
}) => {
  const { t } = useTranslation();

  return (
    <Transition show={show} as={Fragment}>
      <Dialog as="div" className="relative z-30" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>
        <div className="fixed inset-0 z-30 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:inline-block sm:max-w-lg sm:my-8 sm:align-middle">
                <div className="sticky z-10 p-4 bg-gray-50 border-b border-gray-300 flex justify-between items-center">
                  <DialogTitle
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    {t(title)}
                  </DialogTitle>
                  <button
                    type="button"
                    aria-label={t("Close")}
                    onClick={onClose}
                    className="rounded p-1 text-gray-600 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                  >
                    <XIcon aria-hidden="true" className="h-6 w-6" />
                  </button>
                </div>
                <div className="max-h-96 overflow-y-auto overflow-x-hidden">
                  {children}
                </div>
                {footer && (
                  <div className="sticky z-10 bg-gray-50">{footer}</div>
                )}
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};